module.exports = __webpack_public_path__ + "img/industry.cf85e66.webp";